// extracted by mini-css-extract-plugin
export default {"card":"RequestCard_card__J5NeK","header":"RequestCard_header__JZ4JN"};